
import React from 'react';
export const SelectedCategory = ({ selectedType,classes }) => (
    <div className={classes.challengeblock}>
      <h3 className={classes.header}>Category Selected</h3>
      {selectedType?.length > 0 ? (
        <p className={classes.text}>{selectedType.name}</p>
      ) : (
        'No selected Category is available.'
      )}
    </div>
  );
  